module.exports = __webpack_public_path__ + "img/arrow.be0235f8.svg";